import { FormCanvas, FormCheckbox } from "components/form-fields";
import React, { useEffect, useState } from "react";
import { PageRestricted } from "pages/errors/page-restricted";
import { UserAccess } from "components/user-access";
import "./CompleteSignoff.css";
import PropTypes from "prop-types";

export function CompleteSignoff({ onLoading, onSignatureChange, onPrivacyPolicyRead, saving }) {

    const [privacyPolicyRead, setPrivacyPolicyRead] = useState(false);
    const [signature, setSignature] = useState("");
    const [loading, setLoading] = useState(true);
    const requiredAction = "Documents:View";

    const onTogglePrivacyPolicyRead = (e) => {
        setPrivacyPolicyRead(e.target.checked);
        onPrivacyPolicyRead(e.target.checked);
    }

    useEffect(() => {
        setLoading(false);
        onLoading(false);
    }, []);

    useEffect(() => {
        onSignatureChange(signature);
    }, [signature]);

    return (
        <>
            <UserAccess perform={requiredAction}
                yes={() => (
                    <>
                        <p className="spacer-bottom-medium">
                            I the undersigned employee have read, understand and will comply with the attached document for the duration of my employment with the operator.
                        </p>
                        <p className="spacer-bottom-medium">
                            By signing this document, I acknowledge that I am giving consent to Logistics UK via their Vision application to store a digital representation of my signature.
                        </p>
                        <p className="spacer-bottom-medium">
                            <div className="form-field-inline"><FormCheckbox headingText="" disabled={loading || saving} checked={privacyPolicyRead} onChange={onTogglePrivacyPolicyRead} />I have read Logistics UK&nbsp;<a target="_blank" rel="noopener noreferrer" href="https://logistics.org.uk/about-us/policies-and-certificates/fta-privacy-policy">Privacy Policy</a></div>
                        </p>

                        <div className="signature-container">
                            <FormCanvas
                                isLoading={loading}
                                penColour="grey"
                                headingText="Signature"
                                helperText="Please sign in the box below by either drawing with your cursor on desktop or tapping on mobile"
                                onChange={(value) => setSignature(value.split(",").pop())}
                                showDate
                                width="100%"
                                overlayLabel="Please read the Privacy Policy to enable signing."
                                showOverlay={!privacyPolicyRead}
                                format="image/png"
                            />
                        </div>
                    </>)} no={() => (
                        <PageRestricted />
                    )}
            />
        </>
    );
}

CompleteSignoff.propTypes = {
    onLoading: PropTypes.func.isRequired,
    onSignatureChange: PropTypes.func.isRequired,
    onPrivacyPolicyRead: PropTypes.func.isRequired,
    saving: PropTypes.bool.isRequired,
};